import React, { Component } from 'react';

export class TabHolder extends Component{

    render(){
        const { menuItems, children, tabsClass }  = this.props;

        return(
            <div className={ 'clearfix ' + tabsClass }>
                <ul className="nav nav-tabs">
                {
                    menuItems.map( (menu, index)=>{

                        return(
                            <li 
                                key={ index } 
                                className={ menu.active === true ? "active" : "" }>

                                <a data-toggle="tab" href={ "#" + menu.id } onClick={ menu.onClickFn }>
                                    { menu.name }
                                </a>
                            </li>
                        )
                    })
                }
                </ul>

                <div className="tab-content">
                    { children }
                </div>
            </div>
        )
    }
}

export class Tab extends Component{
    
    render(){
        const { menuId, isActive, children, style } = this.props

        return(
            <div 
                id={ menuId } 
                className={ "tab-pane clearfix " + (isActive === true ? "active" : "" ) }
                style={ style }>

                { children }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Tabs.jsx